<div class="add-port-did-form" [formGroup]="form">
  <div class="form-group">
    <label for="add-port-did-phone" translate>company.dids.add-port-did.popup.form.phone.label</label>
    <div class="vox-input-group vox-input-group_dense" [ngClass]="{
      'vox-input-group_invalid': isFieldInvalid('phone') || isPhoneNumberTaken() || form.get('phone').errors?.numberCheckFailed}">
        <vox-phone-text-field [state]="country" [dense]="true" formControlName="phone"
        (input)="onChangeInputValue()"
        (onStateChanged)="onChangeState($event)"></vox-phone-text-field>
        <i *ngIf="!getAsyncPendingStatus()" class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i>
        <i class="vox-text-field__icon vox-text-field__icon_valid ladda"
        [ngClass]="{'ladda-show': !form.controls.phone.valid}" [ladda]="getAsyncPendingStatus()" data-spinner-color="grey"
        data-style="zoom-in"></i>
        <span *ngIf="!form.controls.phone.errors?.numberCheckFailed"
        class="vox-input-group__error-message">{{ getPhoneNumberToken() | translate }}</span>
        <span *ngIf="form.controls.phone.errors?.numberCheckFailed"
        class="vox-input-group__error-message" translate>company.dids.add-port-did.popup.form.phone.errors.failed
          <a (click)="checkValidationAfterApiError()" translate>company.dids.add-port-did.popup.form.phone.errors.click</a>
        </span>
    </div>
  </div>
  <div class="form-group">
    <label for="add-port-did-class" translate>company.dids.add-port-did.popup.form.class.label</label>
    <div ngbDropdown class="vox-dropdown-input">
        <button class="dropdown__btn"
          id="add-port-did-class"
          ngbDropdownToggle>
          <span>{{form.value.class | didClass}}</span>
        </button>
        <div ngbDropdownMenu aria-labelledby="add-port-did-class">
          <button ngbDropdownItem class="dropdown__item" *ngFor="let class of availableClasses"
          (click)="selectDidClass(class)"><span>{{class | didClass}}</span>
          </button>
        </div>
    </div>
  </div>
  <div class="form-group">
    <label for="add-port-did-type" translate>company.dids.add-port-did.popup.form.type.label</label>
    <div ngbDropdown class="vox-dropdown-input">
        <button class="dropdown__btn"
          id="add-port-did-type"
          ngbDropdownToggle><span>{{form.value.type | didType}}</span>
        </button>
        <div ngbDropdownMenu aria-labelledby="add-port-did-type">
          <button ngbDropdownItem class="dropdown__item" *ngFor="let type of availableTypes"
          (click)="selectDidType(type)"><span>{{type | didType}}</span>
          </button>
        </div>
    </div>
  </div>
  <div class="form-group">
    <label for="replace-did-provider" translate>company.dids.replace-with-existing-did.popup.form.provider.label</label>
    <gdp-select-provider ngDefaultControl formControlName="provider" [providers]="availableProviders"></gdp-select-provider>
  </div>
  <div class="form-group">
    <label for="add-port-did-provider-reference" translate>company.dids.add-port-did.popup.form.provider-reference.label</label>
    <div class="vox-input-group vox-input-group_dense">
        <input class="vox-text-field" type="text" id="add-port-did-provider-reference"
            (input)="onChangeInputValue()"
            formControlName="providerReference"
            [placeholder]="'company.dids.add-port-did.popup.form.provider-reference.placeholder' | translate">
    </div>
  </div>
  <div class="form-group">
    <label for="add-port-did-coupon-id" translate>company.dids.add-port-did.popup.form.coupon-id.label</label>
    <div class="vox-input-group vox-input-group_dense">
        <input class="vox-text-field" type="text" id="add-port-did-coupon-id"
            (input)="onChangeInputValue()"
            formControlName="couponId"
            [placeholder]="'company.dids.add-port-did.popup.form.coupon-id.placeholder' | translate">
    </div>
  </div>
</div>